import React from "react";
import { Table, Badge, ProgressBar } from "react-bootstrap";
import { RedactionDetail } from "../../types/shared.types";

interface Props {
  details: RedactionDetail[];
}

const RedactionDetailsTable: React.FC<Props> = ({ details }) => {
  return (
    <div className="mt-4">
      <h5 className="mb-3">Detailed Redaction Breakdown</h5>
      <Table striped bordered hover responsive size="sm">
        <thead>
          <tr>
            <th>#</th>
            <th>Name / Entity</th>
            <th>Count</th>
            <th>Type</th>
            <th>Avg. Confidence</th>
          </tr>
        </thead>
        <tbody>
          {details
            .sort((a, b) => b.count - a.count)
            .map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.name}</td>
                <td>
                  <Badge bg={item.count > 1 ? "warning" : "dark"}>
                    {item.count}
                  </Badge>
                </td>
                <td>
                  <Badge
                    bg={item.entity_type === "PER" ? "success" : "primary"}
                  >
                    {item.entity_type}
                  </Badge>
                </td>
                <td>
                  <ProgressBar
                    now={item.average_confidence * 100}
                    label={`${(item.average_confidence * 100).toFixed(1)}%`}
                    variant={
                      item.average_confidence > 0.9
                        ? "success"
                        : item.average_confidence > 0.75
                        ? "warning"
                        : "danger"
                    }
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  );
};

export default RedactionDetailsTable;
